import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { UseGetQuestionBankQuestionsProps } from ".";

export function useGetQuestionBankQuestions({ crmSystem, organisationId, search = '' }: UseGetQuestionBankQuestionsProps) {
    return useQuery({
        ...queryKeys.question_bank.list._ctx.byOrgId(organisationId!)._ctx.byCrmSystemsArr({ crmSystem, search }),
        staleTime: 0,
        enabled: !!organisationId && !!crmSystem,
    });
}